export const registerServiceWorker = () => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("./firebase-messaging-sw.js", {
        // scope:'/'
      })
      .then((registration) => {
        console.log(
          "Service Worker registered with scope:",
          registration.scope
        );

        // Listen for messages from the service worker
        navigator.serviceWorker.addEventListener("message", (event) => {
          console.log("Message received from service worker:", event.data);
          const { title, body } = event.data.notification || {};
          console.log("Notification Data => ", Notification.permission);
          console.log("Notification Data => ", title);
          console.log("Notification Data => ", body);
          if (event.data && event.data.messageType === "push-received") {
            console.log("Message : ", event);
            if (Notification.permission === "granted") {
              new Notification(title, {
                body: body,
                icon: "", // or your custom icon
                requireInteraction: true,
              });
            } else {
              Notification.requestPermission().then((permission) => {
                if (permission === "granted") {
                  new Notification(title, {
                    body: body,
                    icon: "", // or your custom icon
                    requireInteraction: true,
                  });
                } else {
                  console.warn("Notification permission not granted.");
                }
              });
            }
            window.dispatchEvent(
              new CustomEvent("fcm-notification", { detail: event.data })
            );
            //handlePushMessage(event.data);
          }
          else
          {
            if (Notification.permission === "granted") {
              new Notification("Notification from MH", {
                body: "Notification from MH",
                icon: "", // or your custom icon
                requireInteraction: true,
              });
            } else {
              Notification.requestPermission().then((permission) => {
                if (permission === "granted") {
                  new Notification("Notification from MH", {
                    body: "Notification from MH",
                    icon: "", // or your custom icon
                    requireInteraction: true,
                  });
                } else {
                  console.warn("Notification permission not granted.");
                }
              });
            }
          }
        });
      })
      .catch((error) => {
        console.error("Service Worker registration failed:", error);
      });

    // function handlePushMessage(data) {
    //     // Update the DOM or perform other actions based on the push message data
    //     console.log('Push message received in main thread:'+ data);

    //     // Example: Update a notification area in the DOM
    //     debugger
    //     const notificationArea = document.getElementById('notification-area');

    //     document.getElementsByClassName('badge')[0].innerText=String((parseInt(document.getElementsByClassName('badge')[0].innerText)>99)?'99+':parseInt(document.getElementsByClassName('badge')[0].innerText) + 1);
    //     if (notificationArea) {
    //         notificationArea.innerText = data.notification.body;
    //         document.getElementsByClassName('badge')[0].innerText=String((parseInt(document.getElementsByClassName('badge')[0].innerText)>99)?'99+':parseInt(document.getElementsByClassName('badge')[0].innerText) + 1);
    //     }
    // }
  }
};
